import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="pricing-item"
export default class extends Controller {
  static values = {
    prices: Array,
    cycle: { type: String, default: "yearly" },
  };

  static targets = ["price", "cycle", "stripe"];

  connect() {
    this.change();
  }

  change(event = null) {
    if (!this.hasPriceTarget) {
      return
    }

    if (event) {
      this.cycleValue = event.detail.cycle;
    }

    const price = this.pricesValue.find(
      (price) => price.interval.toLowerCase() === this.cycleValue,
    );


    this.priceTarget.textContent = Number(price.amount).toFixed(2);
    this.cycleTarget.textContent =
      this.cycleValue === "yearly" ? "/ yr" : "/ mo";

    if (!this.hasStripeTarget) {
      return
    }
    let url = new URL(this.stripeTarget.href)
    url.searchParams.set('price', price.id)
    this.stripeTarget.href = url
  }
}
